import Choices from "choices.js";

document.addEventListener("turbolinks:load", () => {
  let choices = document.querySelectorAll("[data-choices]"),
    i;
  for (i = 0; i < choices.length; ++i) {
    new Choices(choices[i], {
      allowHTML: true,
      removeItems: true,
      removeItemButton: true,
    });
  }
});
